export default __webpack_public_path__ + "static/media/scala.92f111af.svg";